import React from 'react';
import { BrowserRouter as Router, Routes, Route } from 'react-router-dom';
import LandingPage from './components/LandingPage';
import MortgageCalculator from './components/MortgageCalculator';
import InvestmentCalculator from './components/InvestmentCalculator';
import PortfolioInvestmentCalculator from './components/PortfolioInvestmentCalculator';
import MonteCarloSimulation from './components/MonteCarloSimulation';
import TestComponent from './components/TestComponent';
import HealthCheck from './components/HealthCheck';
import './App.css';

function App() {
  return (
    <Router>
      <div className="App">
        <Routes>
          {/* Public routes */}
          <Route path="/" element={<LandingPage />} />
          <Route path="/mortgage" element={<MortgageCalculator />} />
          <Route path="/investment" element={<InvestmentCalculator />} />
          <Route path="/portfolio" element={<PortfolioInvestmentCalculator />} />
          <Route path="/monte-carlo" element={<MonteCarloSimulation />} />
          <Route path="/test" element={<TestComponent />} />
          <Route path="/health" element={<HealthCheck />} />
          
          {/* Redirect any unknown routes to home */}
          <Route path="*" element={<LandingPage />} />
        </Routes>
      </div>
    </Router>
  );
}

export default App;
